import api from '../api/axios';

const getSettingsList = () => {
  const response = api.get(`/setting/company`);

  return response;
};

const update = (updatedData) => {
  const response = api.patch(`/setting/company`, updatedData);

  return response;
};

// Email config
const getEmailConfig = () => {
  const response = api.get(`/setting/email`);
  return response;
};

const updateEmailConfig = (config) => {
  const response = api.patch(`/setting/email`, config);
  return response;
};

const testEmailConnection = (target) => {
  // target: 'customers' | 'suppliers'
  const url = target ? `/setting/email/test-connection?target=${target}` : `/setting/email/test-connection`;
  const response = api.post(url);
  return response;
};

const sendTestEmail = (email, target) => {
  // target: 'customers' | 'suppliers'
  const response = api.post(`/setting/email/send-test`, { email, target });
  return response;
};

const getEmailLogs = ({ page = 1, limit = 25, search = '' }) => {
  const response = api.get(`/setting/email/logs?page=${page}&limit=${limit}&search=${search}`);
  return response;
};

const settingsServices = {
  getSettingsList,
  update,
  getEmailConfig,
  updateEmailConfig,
  testEmailConnection,
  sendTestEmail,
  getEmailLogs,
};

export default settingsServices;

const getWorkHours = () => {
  const response = api.get('/setting/work-hours');
  return response;
};

const updateWorkHours = (workHours) => {
  const response = api.patch('/setting/work-hours', workHours);
  return response;
};

settingsServices.getWorkHours = getWorkHours;
settingsServices.updateWorkHours = updateWorkHours;

// Column Order (for appointment matrix)
const getColumnOrder = () => {
  const response = api.get('/setting/column-order');
  return response;
};

const updateColumnOrder = (order) => {
  const response = api.patch('/setting/column-order', { order });
  return response;
};

settingsServices.getColumnOrder = getColumnOrder;
settingsServices.updateColumnOrder = updateColumnOrder;

// Low-price scheduling guard
const getLowPriceGuard = () => {
  const response = api.get('/setting/low-price-guard');
  return response;
};

const updateLowPriceGuard = (guard) => {
  const response = api.patch('/setting/low-price-guard', guard);
  return response;
};

settingsServices.getLowPriceGuard = getLowPriceGuard;
settingsServices.updateLowPriceGuard = updateLowPriceGuard;
